export function normalizeAllowedActions(source) {
  if (Array.isArray(source)) {
    return source.filter((action) => typeof action === "string" && action.trim() !== "");
  }

  if (!source || typeof source !== "object") {
    return [];
  }

  const allowedActions = source.allowed_actions;
  if (!Array.isArray(allowedActions)) {
    return [];
  }

  return allowedActions.filter((action) => typeof action === "string" && action.trim() !== "");
}

export function hasAllowedAction(source, actions) {
  const allowedActions = normalizeAllowedActions(source);
  const expectedActions = Array.isArray(actions) ? actions : [actions];

  return expectedActions.some((action) => allowedActions.includes(action));
}
